import { render } from "./eyeglass.vue?vue&type=template&id=06ed9988"
import script from "./eyeglass.vue?vue&type=script&lang=js"
export * from "./eyeglass.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__